/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { SoftwareOnboardingPageGupsQuery } from './__generated__/SoftwareOnboardingPageGupsQuery.graphql';
import gupsQueryParameters from './__generated__/SoftwareOnboardingPageGupsQuery$parameters';

type SoftwareOnboardingPageEntryPointComponent = EntryPointComponent<
	{
		gupsQuery: SoftwareOnboardingPageGupsQuery;
	},
	{},
	{},
	{} | null
>;

// Explicit type for isolatedDeclarations compliance (AFM blog: hello.atlassian.net/wiki/spaces/afm/blog/2025/09/17/5813532993)
export const softwareOnboardingPageEntryPoint: EntryPoint<
	SoftwareOnboardingPageEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<SoftwareOnboardingPageEntryPointComponent>(
		/* webpackChunkName: "async-software-onboarding-entrypoint" */ './SoftwareOnboardingPage.tsx',
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => ({
		queries: {
			gupsQuery: {
				parameters: gupsQueryParameters,
				variables: { tenantId: cloudId },
				options: { fetchPolicy: 'store-or-network' as const },
			},
		},
		extraProps: {},
	}),
});
